import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WoodTypeListLayer from "../components/WoodTypeListLayer";


export const WoodTypeListPage = () => {
  return (
    <MasterLayout>
      <WoodTypeListLayer/>
    </MasterLayout>
  );
};
